import styled from 'styled-components';
import { IBox, IFlex } from '@/components/OTP/types';

export const ContentStyled = styled.div`
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  display: flex;
  max-width: 650px;
  min-width: 340px;
  z-index: 80;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 900px) {
    flex-direction: column-reverse;
    padding: 16px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    min-width: 340px;
    & > div {
      margin-right: 0;
    }
  }
`;
export const IslemYapilanNumaraTitle = styled.h4`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  color:#333333
  @media screen and (max-width: 900px) {
    font-size: 16px;

  }
  }
`;

export const IslemYapilanNumara = styled.h5`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #333333;
`;

export const Box = styled.div<IBox>`
  flex: 1;
  input {
    margin-bottom: ${({ isError }) => (isError ? '4px' : '24px')};
  }
  @media screen and (max-width: 900px) {
    flex: 2;
  }
`;
export const TextContainer = styled.div`
  margin-bottom: 20px;
`;

export const ChangePhoneNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  // margin-botom:20px;
`;

export const VodafoneTitle = styled.h1`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 20px;

  font-family: VodafoneLt;
  @media screen and (max-width: 480px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;
export const ImageBox = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
  border-radius: 6px;
  min-width: 320px;
  @media screen and (max-width: 900px) {
    min-height: 202px;
    max-width: 100%;
    flex: auto;
    margin-bottom: 16px;
    margin-left: 0px;
  }
`;

export const Title = styled.h2`
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #333;
  margin-bottom: 20px;
  margin-top: 10px;
  @media screen and (max-width: 900px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`;

export const SecondTitle = styled.h2`
  font-size: 20px;
  line-height: 1.4;
  color: #333;
  margin-bottom: 32px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebebeb;
  b {
    font-weight: bold;
  }

  @media screen and (max-width: 900px) {
    margin-bottom: 24px;
  }
`;
export const SMSTitle = styled.div`
  font-size: 28px;
  font-weight: 400;
  line-height: 34px;
  text-align: center;
  color: #333333;
  margin-bottom: 21px;

  @media screen and (max-width: 900px) {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    margin-bottom: 12px;
    color: #262626;
  }
`;

export const SecondBox = styled.div<IBox>`
  flex: 1;

  input {
    margin-bottom: ${({ isError }) => (isError ? '4px' : '24px')};
  }
`;

export const SecondContent = styled.div`
  padding: 20px;
  border-radius: 6px;
  z-index: 80;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  display: flex;
  flex: 2;
  max-width: 610px;

  @media screen and (max-width: 900px) {
    flex-direction: column-reverse;
    padding: 16px;
    & > div {
      margin-right: 0;
    }
  }
`;

export const Flex = styled.div<IFlex>`
  display: flex;
  width: 100%;
  gap: ${({ gap }) => (gap ? `${gap}px` : '21px')};
`;

export const FlexBox = styled(Flex)<any>`
  padding-bottom: ${({ isPwPage }) => (isPwPage ? '24px' : '64px')};
  max-width: 1030px;
`;

export const FlexBoxOTP = styled(Flex)<any>`
  padding-bottom: ${({ isPwPage }) => (isPwPage ? '24px' : '64px')};
  max-width: 1030px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const ChangeNumber = styled.div`
  flex: 1;
  height: 88px;
  z-index: 80;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  padding: 32px 20px;

  h3 {
    font-size: 18px;
    line-height: 1.33;
    color: #e60000;

    &:hover {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const ErrorMessage = styled.p`
  color: #e60000;
  margin-bottom: 8px;
  margin-left: 14px;
  font-size: 14px;
  line-height: 1.29;
`;

export const ErrorMessageOneClick = styled.p`
  color: #e60000;
  //margin-bottom: 8px;
  margin-left: 25px;
  font-size: 14px;
  line-height: 1.29;
`;

export const NotificationBoxAlert = styled.div`
  width: 100%;
  max-width: 610px;
  border: 1.5px solid #e60000;
  border-radius: 6px;
  display: flex;
  margin: 20px 0px;
  flex-direction: row;
  text-align: center;
  justify-content: flex-start;
  .icon {
    background: red;
    width: 42px;
    border-bottom: 1px solid #e60000;
    padding: 8px 0;
    display: flex;
    justify-content: center;
  }
  .text {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    color: #333333;
    padding: 15px 10px;
  }
  @media (max-width: 480px) {
    width: 100%;
    border: 1px solid #e60000;
    .icon {
      width: 48px !important;
    }
    .text {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;
